import { useState } from 'react';
import fleetApi from '../../services/api.service';

export default function useUpdatePhoneNumber() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const updatePhoneNumber = async (id, title, phoneNumber, isArchived) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.put(`/clients/phone-numbers/${id}`, {
        title,
        phone_number: phoneNumber,
        is_archived: isArchived,
      });

      if (response.status === 200) {
        setIsSuccess(true);
        return response.data.phone_number;
      } else {
        setIsSuccess(false);
        throw new Error(
          response.data.message || 'Erreur lors de la mise à jour'
        );
      }
    } catch (error) {
      setError(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue lors de la mise à jour du numéro de téléphone.'
      );
      setIsSuccess(false);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setError('');
    setIsSuccess(false);
    setIsLoading(false);
  };

  return {
    error,
    isLoading,
    isSuccess,
    updatePhoneNumber,
    resetStates,
  };
}
